import { useQuery } from '@tanstack/react-query';
import getDocumentContentService from '../../service/getDocumentContent/getDocumentContent.service';
import { overlayState$ } from '../../state';

export const IUseGetDocumentContentKey = 'IUseGetDocumentContentKey';

export function useQueryGetDocumentContent(isEnabled: boolean, payload: string) {
  return useQuery({
    queryKey: [IUseGetDocumentContentKey, payload],
    enabled: isEnabled,
    queryFn: ({ signal }) => getDocumentContentService({ signal, payload }),
    select: (data) => {
      // Need to make this async
      overlayState$.activeItemId.set(payload);
      overlayState$.activeItem.set(data.data);
      const url = URL.createObjectURL(data.data);
      return {
        content: url,
        contentType:
          data?.headers && 'get' in data.headers && typeof data.headers.get === 'function' ? data.headers.get('Content-Type') : 'application/pdf',
        title: payload.slice(payload.lastIndexOf('/') + 1),
      };
    },
  });
}
